import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
var namespace = 'recruit-store';
export default {
  store: store,
  mounted: function mounted() {
    this.getRecruitList();
  },
  computed: _objectSpread({}, mapState(namespace, ['recruit_list']), {}, mapGetters('recruit-store', ['recruitListAll']), {}, mapGetters('app', ['h'])),
  methods: _objectSpread({}, mapActions(namespace, ['getRecruitList'])),
  filters: {
    addRecruitText: function addRecruitText(value) {
      return value + "の求人一覧";
    },
    hasJobName: function hasJobName(_ref) {
      var title = _ref.title,
          jobName = _ref.jobName;

      if (jobName) {
        return "".concat(title, "\uFF5C").concat(jobName);
      }

      return title;
    },
    hasLinkText: function hasLinkText(value) {
      if (value) {
        return value;
      }

      return "募集要項はこちら";
    }
  }
};